import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { CBQExamDTO } from "./InitCBQExam";

export interface UpdateCBQExamPayload {
  title?: string;
  description?: string;
  mode?: string;
  lectureId?: string;
  // PROD_WITH_MCQ gate: existing MCQ quiz + score (%) needed to unlock the CBQ.
  quizId?: string;
  requiredQuizScore?: number;
}

type UpdateCBQExamResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: CBQExamDTO;
};

export const UpdateCBQExam = async ({
  id,
  payload,
}: {
  id: string;
  payload: UpdateCBQExamPayload;
}): Promise<UpdateCBQExamResponse> => {
  try {
    const response = await axios.patch(`/admin/cbq/exams/${id}`, payload);
    return { data: response.data?.data ?? response.data };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
